module.exports = "/fonts/Gineso-Norm-Regular.svg";